module.exports = __webpack_public_path__ + "static/media/linkein.186f7065.svg";